import { render } from "./SidebarMenu3.vue?vue&type=template&id=5f917ae7&scoped=true"
import script from "./SidebarMenu3.vue?vue&type=script&lang=js"
export * from "./SidebarMenu3.vue?vue&type=script&lang=js"

import "./SidebarMenu3.vue?vue&type=style&index=0&id=5f917ae7&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f917ae7"]])

export default __exports__